<template>
  <div class="check-account-content">
    <div class="content">
      <ul class="account-card">
        <li v-if="isAdmin">
          <h2 style="margin-bottom:10px">选择统计维度</h2>
          <el-select class="search-input-item" style="margin-right:10px;margin-bottom:10px" v-model="byYear"
                     placeholder="全部年份" @change="changeYear">
            <el-option label="全部年份" value=""></el-option>
            <el-option
              v-for="item in new Date().getFullYear() - 2018"
              :key="item"
              :label="(2018 + item) + '年'"
              :value="2018 + item">
            </el-option>
          </el-select>
          <el-select class="search-input-item" style="margin-right:10px" v-model="byMonth"
                     placeholder="全部月份" @change="doSearch">
            <el-option label="全部月份" value=""></el-option>
            <el-option
              v-for="item in byMonths"
              :key="item"
              :label="(3 * item - 2) + '~' + (3 * item) + '月'"
              :value="item">
            </el-option>
          </el-select>
        </li>
        <li>
          <h2>{{isAdmin?'平台总充值':'总充值'}}</h2>
          <h2>数据截至今日</h2>
          <h2>￥{{accountData.rechargeTotal}}</h2>
        </li>
        <li>
          <h2>{{isAdmin?'平台总扣费':'总消费'}}</h2>
          <h2>数据截至今日</h2>
          <h2>￥{{accountData.deductTotal}}</h2>
        </li>
        <li>
          <h2>{{isAdmin?'检测站总余额':'我的余额'}}</h2>
          <h2>数据截至今日</h2>
          <h2>￥{{accountData.balance}}</h2>
          <button v-if="!isAdmin" @click="toRecharge">充值</button>
        </li>

      </ul>

      <el-tabs v-model="activeName" type="border-card" style="width:100%; min-height: 600px" closable
               @tab-remove="closeBillDetail" @tab-click="switchTab">
        <el-tab-pane label="对账单列表" name="billList" class="checkList">
          <div v-if="!isAdmin && existsUnchecked" class="warning-message">
            <img style="width:20px;height:20px;" src="../assets/warning.png" alt="">
            您本期对账未完成！请在15号前尽快完成对账，过了15号没欠费但未完成对账的，将默认视为确认对账；存在欠费的账号将会被冻结。如账单有疑异，请尽快联系工作人员电话15251611230处理！
          </div>
          <div class="search-box">
            <el-form :inline="true">
              <el-form-item label="账单年度">
                <el-select v-model="searchTermForMerchant" @change="listStatements">
                  <el-option v-for="item in maxMerchantTerm"
                             :key="item" :label="(2019 + item - 1) + '年'" :value="item"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="账期" v-if="isAdmin" >
                <el-select
                  v-model="searchTerm"
                  placeholder="选择账期"
                  @change="listStatements"
                >
                  <el-option v-for="item in maxTerm" :key="item"
                             :label="(2019 + Math.floor((maxTerm - item) / 4)) + '年 ' + (Math.floor((maxTerm - item) % 4) * 3 + 1) + '~' + (Math.floor((maxTerm - item) % 4 + 1)) * 3 + '月'"
                             :value="maxTerm - item + 1">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="机构名称" v-if="isAdmin">
                <el-input placeholder="输入关键字" v-model="searchOrgName" clearable @change="listStatements"> </el-input>
              </el-form-item>
              <el-form-item label="对账单编号" v-if="isAdmin">
                <el-input placeholder="输入关键字" v-model="searchCheckBillNum" clearable> </el-input>
              </el-form-item>
              <el-form-item label="对账状态" v-if="isAdmin">
                <el-select class="search-input-item" v-model="searchStatus"
                           placeholder="请选择对账状态" clearable @change="listStatements">
                        <el-option
                          v-for="item in billStatusList"
                          :key="item.value"
                          :label="item.text"
                          :value="item.value">
                        </el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" icon="el-icon-search" @click="listStatements">查询</el-button>
                <el-button type="primary" @click="createStatements" v-if="isAdmin">发起本期对账</el-button>
                <el-button type="primary" @click="restFrom1">清空</el-button>
              </el-form-item>
            </el-form>
          </div>
          <el-table
            :data="checkList"
            style="width: 100%; margin-top:20px"
            :cellStyle="negativeStyle">
            <el-table-column
              label="对账单账期">
              <template slot-scope="scope">
                <span>{{ scope.row.year }}年{{ (scope.row.term - 1) * 3 + 1 }}~{{(scope.row.term) * 3}}月</span>
              </template>
            </el-table-column>
            <el-table-column
            prop="merchantName"
            label="检测机构" v-if="isAdmin">
            </el-table-column>
            <el-table-column
              prop="billNo"
              label="对账单编号">
            </el-table-column>
            <el-table-column
              prop="uploadCount"
              label="上传单数">
            </el-table-column>
            <el-table-column
              prop="deduct"
              label="总消费">
            </el-table-column>
            <el-table-column
              prop="recharge"
              label="总充值">
            </el-table-column>
            <el-table-column
              prop="lastTermBalance"
              label="上期余额">
            </el-table-column>
            <el-table-column
              prop="balance"
              label="本期余额">
            </el-table-column>
            <el-table-column
              label="对账状态">
              <template slot-scope="scope">
                <span v-if="scope.row.status === 1" style="color:#ff9000">待发送</span>
                <span v-else-if="scope.row.status === 2" style="color:red">未对账</span>
                <span v-else-if="scope.row.status === 3" style="color: green">已确认</span>
                <span v-else-if="scope.row.status === 4" style="color:red">不相符<br/>{{scope.row.remark}}</span>
              </template>
            </el-table-column>
            <el-table-column
              fixed="right"
              label="操作"
            >
              <template slot-scope="scope">
                <el-button v-if="isAdmin && scope.row.status === 1" @click="sendBill(scope.row)" type="text" size="small">发送对账单</el-button>
                <el-button v-if="isAdmin && scope.row.status === 4" @click="sendBill(scope.row)" type="text" size="small">重新发送</el-button>
                <el-button v-if="!isAdmin && scope.row.status === 2" @click="showConfirmBillDialog(scope.row)" type="text"
                           size="small">确认对账
                </el-button>
                <el-button @click="billDetail(scope.row)" type="text" size="small">详单</el-button>

              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @size-change="handleSizeChange" style="text-align: right;margin-top: 25px;"
            @current-change="handleCurrentChange"
            :current-page="pageInfo.pageNum"
            :page-sizes="[2, 10, 20, 30, 100]"
            :page-size="pageInfo.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pageInfo.total">
          </el-pagination>
        </el-tab-pane>
        <el-tab-pane label="账单详情" :name="'billDetail' + bill.billNo" class="checkList bill-detail"
                     v-for="bill in billDetailList" :key="bill.id">
          <div v-if="!isAdmin && bill.status === 2" class="warning-message">
            <img style="width:20px;height:20px;" src="../assets/warning.png" alt="">
            您本期对账未完成！请在15号前尽快完成对账，过了15号没欠费但未完成对账的，将默认视为确认对账；存在欠费的账号将会被冻结。如账单有疑异，请尽快联系工作人员电话15251611230处理！
          </div>
          <div class="merchant-name" v-if="isAdmin">
            {{ bill.merchantName }}
          </div>
          <div class="billSummary">
            <span>账期:{{bill.year}}年{{(bill.term - 1) * 3 + 1}}~{{bill.term * 3}}月</span>
            <span>上传单数:{{bill.uploadCount}}</span>
            <span>本期消费:{{bill.deduct}}</span>
            <span>本期充值:{{bill.recharge}}</span>
            <span>上期余额:{{bill.lastTermBalance}}</span>
            <span>本期余额:{{bill.balance}}</span>
            <el-button type='primary' v-if="!isAdmin && bill.status === 2" @click="showCheckModal=true;">确认对账</el-button>
          </div>
          <div class="search-box">
            <el-form :inline="true">
              <el-form-item label="日期：">
                <el-date-picker class="search-input-item"
                            v-model="transactionDate"
                            type="daterange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            value-format='yyyy-MM-dd'
                            :default-value="defaultDate"
                            :picker-options="transactionDateOption(bill)">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="交易类型：">
                <el-select class="search-input-item" v-model="billType" placeholder="请选择交易类型" clearable>
                  <el-option
                    v-for="item in billTypes"
                    :key="item.value"
                    :label="item.text"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="操作人/检车流水：">
                <el-input class="search-input-item" v-model="searchOperator"
                      placeholder="请输入关键字" clearable></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="listTransactions(bill)" icon="el-icon-search">查询</el-button>
                <el-button type="primary" @click="downloadTransactions(bill)" icon="el-icon-download">导出</el-button>
              </el-form-item>
            </el-form>
          </div>
          <el-table
            :data="transactionList"
            style="width: 100%">
            <el-table-column
              prop="id"
              label="序号"
              width="100">
            </el-table-column>
            <el-table-column
              prop="createTime"
              label="交易时间"  width="100">
            </el-table-column>
            <el-table-column
              label="交易类型" width="120">
              <template slot-scope="scope">
                <span v-if="scope.row.transactionType === 'RECHARGE'">充值</span>
                <span v-else-if="scope.row.transactionType === 'REVERSE'">冲正</span>
                <span v-else-if="scope.row.transactionType === 'DEDUCT'">
                  <b v-if="scope.row.chargeCount > 1" style="color: red">
                    退回后{{ scope.row.chargeCount }}次上传扣费
                  </b>
                  <b v-else>
                    首次上传扣费
                  </b>
                </span>
              </template>
            </el-table-column>
            <el-table-column
              prop="transactionAmount"
              label="交易金额" width="120">
            </el-table-column>
            <el-table-column
              prop="afterAmount"
              label="交易后余额" width="120">
            </el-table-column>
            <el-table-column
              prop="operator"
              label="操作员/检车流水">
            </el-table-column>
            <el-table-column
              prop="description"
              label="备注">
            </el-table-column>
          </el-table>
          <el-pagination
            @size-change="handleSizeChange2" style="text-align: right;margin-top: 25px;"
            @current-change="handleCurrentChange2"
            :current-page="pageInfo2.pageNum"
            :page-sizes="[2, 10, 20, 30, 100]"
            :page-size="pageInfo2.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pageInfo2.total">
          </el-pagination>
        </el-tab-pane>
      </el-tabs>
    </div>
    <el-dialog
      title="请确认对账情况"
      :visible.sync="showCheckModal"
      width="38%" custom-class="check_dialog">
      <div class="modal-content" style="padding:20px">
        <div class="modal-content-item">
          <el-form v-if="selectedBill" :model="checkForm" ref="checkForm">
            <el-form-item label="检测机构名称：">
              {{selectedBill.merchantName}}
            </el-form-item>
            <el-form-item label="余额截至日期：">
              {{selectedBill.year}}/{{selectedBill.term === 1 ? '03/31' : (selectedBill.term === 2 ? '06/30' : (selectedBill.term === 3 ? '09/30' : '1231'))}}
            </el-form-item>
            <el-form-item label="账户余额：" class="balance_item">
              ￥{{selectedBill.balance}}
            </el-form-item>
            <el-form-item label="核对结果：">
              <el-select v-model="checkForm.checkResult" :class="{'error' : checkResultError}" @change="changeCheckResult">
                <el-option value="" label="请选择"></el-option>
                <el-option value="3" label="相符"></el-option>
                <el-option value="4" label="不相符"></el-option>
              </el-select>
              <div v-if="checkResultError" style="color:red;margin-left:90px">请选择核对结果</div>
            </el-form-item>
            <el-form-item  v-if="checkForm.checkResult === '4'">
              <el-input type="textarea" v-model="checkForm.checkRemark" placeholder="您可在此简单描述不相符的内容"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <p style="color:red;font-size:15px;margin:20px;line-height: 20px; text-align:left">
          友情提醒：“余额不足”或“未在15号之前完成对账”将会被冻结账号，影响正常上传！</p>
      </div>
      <div slot="footer" class="dialog-footer">
        <div>
          <el-button @click="showCheckModal = false">取 消</el-button>
          <el-button type="primary" @click="doConfirmBill">确 定</el-button>
        </div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
  import {
    accountOverview, confirmBill,
    createStatements,
    listStatements,
    listTransactions,
    sendBill
  } from '../modules/services/basic-service'
  import moment from 'moment'

  export default {
    data() {
      return {
        dsId: '',
        showCheckModal: false,
        isArrearage: false,
        isAdmin: true,
        thisActive: '1',
        searchOrgName: '',
        searchCheckBillNum: '',
        searchTerm: 1,
        searchTermForMerchant: new Date().getFullYear() - 2018,
        byYears: 0,
        byMonths: 0,
        byYear: '',
        byMonth: '',
        accountData: {
          deductTotal: 3000,
          rechargeTotal: 25000,
          balance: 41200
        },
        activeName: 'billList',
        activeName2: '0',
        billDetailList: [],
        transactionList: [],
        checkList: [
          {
            year: '2019',
            term: 1,
            uploadCount: 1000,
            billNo: '21321321',
            deduct: 100,
            recharge: 1000,
            lastTermBalance: 100,
            balance: 900,
            status: 1
          }],
        transactionDate: '',
        billType: '',
        searchStatus: '',
        billTypes: [{
          value: 'RECHARGE',
          text: '充值'
        }, {
          value: 'REVERSE',
          text: '冲正'
        }, {
          value: 'DEDUCT',
          text: '扣费'
        }],
        billStatusList: [{
          value: '1',
          text: '待发送'
        }, {
          value: '2',
          text: '未对账'
        }, {
          value: '3',
          text: '已确认'
        }, {
          value: '4',
          text: '不相符'
        }],
        searchOperator: '',
        pageInfo: {
          pageSize: 10,
          pageNum: 1,
          total: 100
        },
        pageInfo2: {
          pageSize: 10,
          pageNum: 1,
          total: 50
        },
        payNum: '',
        searchYear: '',
        selectedBill: null,
        minDate: '',
        maxDate: '',
        thisBill: {
          name: ''
        },
        checkForm: {
          checkResult: '',
          checkRemark: ''
        },
        checkResultError: false
      }
    },
    computed: {
      defaultDate () {
        return moment(this.minDate).add(1, 'days').format('YYYY-MM-DD')
      },
      maxTerm () {
        return (new Date().getFullYear() - 2019) * 4 + Math.floor(new Date().getMonth() / 3)
      },
      maxMerchantTerm () {
        return new Date().getFullYear() - 2018
      },
      existsUnchecked () {
        for (var i = 0; i < this.checkList.length; i++) {
          if (this.checkList[i].status === 2) {
            return true;
          }
        }
        return false;
      }
    },
    methods: {
      transactionDateOption () {
        const self = this;
        return {
          disabledDate: (time) => {
            return !moment(time).isBetween(self.minDate, self.maxDate, null, '[]')
          }
        }
      },
      doSearch() {
        const self = this
        accountOverview(this.dsId, this.byYear, this.byMonth).then(({body}) => {
          if (body) {
            self.accountData = body
          }
        })
      },
      switchTab (tab) {
        const self = this
        if (tab.name === 'billList') {
          self.selectedBill = null
          return
        }
        if (tab.name === self.activeName) {
          return;
        }
        self.activeName = tab.name
        this.billDetailList.forEach(bill => {
          if ('billDetail' + bill.billNo === tab.name) {
            self.selectedBill = bill
            self.minDate = moment({y:bill.year, M: (bill.term - 1) * 3, d: 1})
            if (bill.term > 3) {
              self.maxDate = moment({y: parseInt(bill.year) + 1, M: 0, d: 1}).subtract(1, 'days')
            } else {
              self.maxDate = moment({y: bill.year, M: (bill.term * 3), d: 1}).subtract(1, 'days')
            }
            self.listTransactions(bill)
          }
        })
      },
      changeCheckResult (result) {
        if (result) {
          this.checkResultError = null
        }
      },
      listTransactions () {
        const self = this
        let from, to;
        if (self.transactionDate) {
          from = self.transactionDate[0]
          to = self.transactionDate[1]
        } else {
          from = moment(this.minDate).format('YYYY-MM-DD')
          to = moment(this.maxDate).format('YYYY-MM-DD')
        }
        listTransactions(this.pageInfo2.pageNum, this.pageInfo2.pageSize, this.selectedBill.dsId, from, to, this.billType, this.searchOperator).then(({body}) => {
          if (body) {
            self.transactionList = body.data
            self.pageInfo2.total = body.total
          }
        })
      },
      downloadTransactions () {
        const self = this;
        let from, to;
        if (self.transactionDate) {
          from = self.transactionDate[0];
          to = self.transactionDate[1];
        } else {
          from = moment(this.minDate).format('YYYY-MM-DD');
          to = moment(this.maxDate).format('YYYY-MM-DD');
        }
        window.open("/detect/finance/api/transaction/export?start=" + from + "&end=" + to, "_blank")
      },
      closeBillDetail (targetName) {
        if (targetName === 'billList') return;
        let tabs = this.billDetailList;
        let activeTabName = this.activeName;
        if (activeTabName === targetName) {
          tabs.forEach((tab, index) => {
            if ('billDetail' + tab.billNo === targetName) {
              let nextTab = tabs[index + 1] || tabs[index - 1];
              if (nextTab) {
                activeTabName = 'billDetail' + nextTab.name;
              } else {
                activeTabName = 'billList'
              }
            }
          });
        }

        this.activeName = activeTabName;
        this.billDetailList = tabs.filter(tab => ('billDetail' + tab.billNo) !== targetName);
      },
      listStatements () {
        const self = this;
        let year, term;
        if (this.isAdmin) {
          year = this.searchTerm ? Math.floor((this.searchTerm - 1) / 4) + 2019 : '';
          term = this.searchTerm ? (this.searchTerm - 1) % 4 + 1 : ''
        } else {
          year = 2019 + this.searchTermForMerchant - 1;
          term = this.searchTermForMerchant * 4 - 3;
        }
        listStatements(this.pageInfo.pageNum, this.pageInfo.pageSize, year, term,
          this.searchOrgName, this.searchCheckBillNum, this.searchStatus)
          .then(({body}) => {
            if (body) {
              self.pageInfo.total = body.total;
              self.checkList = body.billStatements
            }
          })
      },
      createStatements () {
        const self = this
        let year = this.searchTerm ? Math.floor((this.searchTerm - 1) / 4) + 2019 : ''
        let term = this.searchTerm ? (this.searchTerm - 1) % 4 + 1 : ''
        createStatements(year, term).then(({body}) => {
          if (body) {
            self.listStatements()
          }
        }, ({header}) => {
          this.$alert(header.message, '提示', {
            confirmButtonText: '确定',
            callback: () => {
              self.listStatements()
            }
          });
        })
      },
      negativeStyle (item) {
        if ((item.column.property === 'balance' && item.row.balance < 0) ||
          (item.column.property === 'deduct' && item.row.deduct < 0) ||
          (item.column.property === 'recharge' && item.row.recharge < 0) ||
          (item.column.property === 'lastTermBalance' && item.row.lastTermBalance < 0)) {
          return "color: red"
        }
      },
      changeYear () {
        this.byMonth = ''
        if (!this.byYear) {
          this.byMonths = ''
        } else if (this.byYear === new Date().getFullYear()) {
          this.byMonths = Math.floor(new Date().getMonth() / 3) + 1
        } else {
          this.byMonths = 4
        }
        this.doSearch()
      },
      doConfirmBill() {
        if (!this.checkForm.checkResult) {
          this.checkResultError = true
        } else {
          this.confirmBill()
        }
      },
      showConfirmBillDialog (bill) {
        this.selectedBill = bill
        this.showCheckModal = true
        this.checkForm.checkResult = ''
        this.checkForm.checkRemark = ''
      },
      toRecharge() {
        if (top.location.href !== self.location.href) {
          top.location.href = '/detect/finance/mine-account?pay=1'
        } else {
          this.$router.push({
            path: '/my-account?pay=1'
          })
        }
      },
      sendBill(bill) {
        const self = this
        sendBill(bill.id).then(({body}) => {
          if (body) {
            self.listStatements()
          }
        })
      },
      handleSizeChange(val) {
        this.pageInfo.pageSize = val
        this.listStatements()
      },
      handleCurrentChange(val) {
        this.pageInfo.pageNum = val
        this.listStatements()
      },
      handleSizeChange2(val) {
        this.pageInfo2.pageSize = val
        this.listTransactions()
      },
      handleCurrentChange2(val) {
        this.pageInfo2.pageNum = val
        this.listTransactions()
      },
      confirmBill() {
        const self = this
        this.showCheckModal = false
        confirmBill(this.selectedBill.id, this.checkForm.checkResult, this.checkForm.checkRemark)
          .then(({body}) => {
            if (body) {
              self.listStatements()
            }
          })
      },
      billDetail(bill) {
        let exists = false
        this.billDetailList.forEach((tab) => {
          if (tab.billNo === bill.billNo) {
            exists = true;
          }
        });
        if (!exists) {
          this.billDetailList.push(bill)
        }
        this.switchTab({name: 'billDetail' + bill.billNo})
      },
      restFrom1(){
        this.searchOrgName=''
        this.searchStatus=''
        this.searchCheckBillNum=''
      }
    },
    mounted() {
      this.isAdmin = !!this.$route.query.isAdmin;
      this.doSearch();
      this.listStatements()
    }
  }
</script>

<style scoped lang='stylus'>
  .check-account-content {
    .bill-detail {
      .search-box {
        margin-top: 20px;
      }
    }
    .content {
      padding: 5px;
    }
    .warning-message {
      height: 30px;
      line-height: 30px;
      display: flex;
      align-items: center;
      color: red;
      margin-bottom: 30px;
    }
    .account-card {
      border-bottom: 1px dashed #eee;
      margin-bottom 30px
      display: flex;
      flex-wrap: wrap;
      li {
        width: 260px;
        height: 190px;
        line-height: 20px;
        border-radius: 10px;
        box-shadow: 0px 0px 8px 0px rgba(145, 142, 142, 1);
        border: 1px solid rgba(255, 255, 255, 0);
        list-style: none;
        float left
        margin 0 20px 20px 0
        box-sizing border-box
        padding 20px
        position relative
        button {
          position absolute
          top 20px
          right 10px
          background #666666
          color white
          width 80px
          height 30px
          border none
          cursor pointer
        }
        h2:first-child {
          color #666363
          font-size 24px
          margin-bottom 15px
        }
        h2:nth-child(2) {
          color #7D7D7D
          font-size 14px
          margin-bottom 25px
        }
        h2:nth-child(3) {
          color #101010
          font-size 36px
          margin-bottom 10px
        }

      }

    }
    .search-input-item {
      margin 0 40px 0 10px
    }
    .search-box {
    }
    .saomaContent {
      display flex
      flex-direction: row
      justify-content: space-around;
    }
    .sContent {
      border-bottom 1px dashed #eee
      padding 20px 0
      text-align center
      h3 {
        color #101010
        font-weight bold
        margin-bottom 20px
        font-size 24px
      }
      h4 {
        color #E51C23
        font-size 13px
      }
      p {
        margin 20px 0
        color #101010
        font-weight bold
        span {
          font-weight normal
        }
      }
    }
    .tips01 li, .tips02 li {
      margin-top 25px
      font-size 18px
    }
    .tips01 {
      li:first-child {
        font-weight bold
      }
      padding-bottom 30px
      border-bottom 1px solid #eee
    }
    .tips02 li {
      &:nth-child(2), &:nth-child(3), &:nth-child(4) {
        font-weight bold
        padding-left 50px
      }
      &:last-child {
        color #E51C23
      }
    }
    .checkList {
      h3 {
        color #E51C23
      }
    }
    .merchant-name {
      margin-top: 10px;
    }
    .billSummary {
      padding 10px
      border 1px solid #eee
      margin-top 20px
      color: #666
      font-size: 15px
      span {
        margin 0 20px
      }
    }
    .modal-content-item {
      padding: 20px
      background #fafafa
      border 1px dashed #bbb
      p {
        text-align center
        font-size 18px
        margin-top 10px
      }
    }
  }
  .check_dialog {
    label {
      font-size: 15px;

    }
  }
</style>
<style lang="stylus">
  .check_dialog {
    .el-form {
      font-size: 16px;
    }
    .el-form-item {
      margin-bottom: 24px;
      .el-form-item__label, .el-form-item__content {
        font-size: 16px;
      }
      &.balance_item {
        .el-form-item__content {
          font-size: 20px;
          color: red;
          font-weight: bold;
        }
      }
    }
    .el-select.error {
      .el-input__inner {
        border-color: red
      }
    }
  }
</style>